import { ITaxData } from '@/models';
import { ITaxService } from './tax.types';
import { AxiosInstance } from 'axios';

export class TaxService implements ITaxService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/taxes/';
  }

  fetchTaxes(): Promise<ITaxData[]> {
    return this.axios
      .get<ITaxData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchTax(id: number): Promise<ITaxData> {
    return this.axios
      .get<ITaxData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createTax(data: ITaxData): Promise<ITaxData> {
    return this.axios
      .post<ITaxData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateTax(data: ITaxData): Promise<ITaxData> {
    return this.axios
      .patch<ITaxData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteTax(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
